export default __webpack_public_path__ + "static/ecki@2x-aa27cde72e131db571135ca7068188a7.png";